import React from 'react';

const CoopModelSection = () => {
  return (
    <section className="bg-soft-earth py-16 px-6 md:px-20 text-center">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl md:text-4xl font-extrabold text-primary mb-12">
          How the Cooperative Model Works
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-cool-gray">
            <div className="text-4xl mb-3">🧩</div>
            <h4 className="text-xl font-semibold mb-2 text-deep-navy">
              1. Join the Co-op
            </h4>
            <p className="text-gray-700">
              Become part of a shared retail movement. No upfront cost — just
              collaboration, visibility, and mutual growth.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-cool-gray">
            <div className="text-4xl mb-3">📊</div>
            <h4 className="text-xl font-semibold mb-2 text-deep-navy">
              2. Share Your Sales Data
            </h4>
            <p className="text-gray-700">
              Your POS system securely feeds anonymized data to the co-op,
              enabling smarter assortments and collective bargaining power.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-cool-gray">
            <div className="text-4xl mb-3">💡</div>
            <h4 className="text-xl font-semibold mb-2 text-deep-navy">
              3. Unlock Insights
            </h4>
            <p className="text-gray-700">
              Gain access to real-time analytics tailored to your store — and
              benchmarked against the broader co-op network.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoopModelSection;
